<template>
  <div>
    <div class="grid ver-padding-40">
      <h1 class="r-margin-30">Добавить IP</h1>
    </div>

    <div>
      <form
          @submit.prevent="onSubmit"
          @keypress.enter="pressEnter"
          class="grid"
      >
        <div class="page-block u-16 grid cross-center between">
          <!-- address -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
                v-model="form.address"
                label="IP адрес"
                size="medium"
                required
                @blur="validateAddress(form.address, true)"
                @input="validateAddress(form.address, false)"
            ></AppInput>
          </div>

          <!-- description -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
                v-model.trim="form.description"
                label="Описание"
                size="medium"
            ></AppInput>
          </div>
        </div>
        <!-- submit -->
        <div class="u-16 ver-margin-20">
          <AppButton class="r-margin-20" :disabled="disableButton"
          >Добавить</AppButton
          >
          <AppButton type="border" @click.prevent="cancel">Отменить</AppButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import errors from "@/localize/errors.js";
Vue.use(VueAxios, axios);

export default {
  name: "AddWhitelist",
  data() {
    return {
      loading: false,
      form: {
        address: "",
        description: ""
      },
      validateStack: {
        address: false
      },
      is_disabled: true
    }
  },
  methods: {
    onSubmit() {
      let req = { ...this.form };
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };

      axios
      .post(
          apiUrl + "whitelist/create",
          req,
          config
      )
      .then(({ data }) => {
        if (data.state_id == 0) {
          this.showError("IP адрес успешно добавлен", "success");
          this.cancel();
        } else {
          if (errors.message.hasOwnProperty(data.message))
            this.showError(errors.message[data.message]);
          else this.showError(errors.message["default"]);
          return false;
        }
      })
      .catch(err => {
        console.log(errors);
        if (err.response) this.showError(err.response.data.message);
      });
    },
    cancel() {
      this.$router.push({
        name: "s_Whitelist"
      });
    },
    pressEnter(e) {
      e.preventDefault();
    },
    validateAddress(address, is_shown_message) {
      if (address) {
        let re = /^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\/([0-9]|[1-2][0-9]|3[0-2])$/;
        setTimeout(() => {
          if (!re.test(address)) {
            if (is_shown_message)
              this.showError(
                  "Некорректный IP"
              );
            this.validateStack.address = false;
            return false;
          } else {
            this.validateStack.address = true;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message) this.showError("Введите IP");
        this.validateStack.address = false;
        return false;
      }
    },
    showError(text, type) {
      type = type ? type : "error";
      this.$message({
        showClose: true,
        message: text,
        type: type,
        duration: 3000
      });
    },
  },
  computed: {
    disableButton() {
      let count = 0;
      for (let key in this.validateStack) {
        if (this.validateStack[key]) count++;
        else count = 0;
      }
      return count == 0;
    }
  }
}
</script>
